module.exports = __webpack_public_path__ + "img/four_content_item_bg_01.436c9c96.png";